import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GridWidgetComponent } from './grid-widget/grid-widget.component';
import { SampleStatusWidgetComponent } from './sample-status-widget/sample-status-widget.component';
import { ExceedanceComplianceWidgetComponent } from './exceedance-compliance-widget/exceedance-compliance-widget.component';
import { EquipmentCalibrationStatusWidgetComponent } from './equipment-calibration-status-widget/equipment-calibration-status-widget.component';
import { SurveyProgressWidgetComponent } from './survey-progress-widget/survey-progress-widget.component';
import { SampleCollectionMetricsWidgetComponent } from './sample-collection-metrics-widget/sample-collection-metrics-widget.component';
import { SegProfileSummaryWidgetComponent } from './seg-profile-summary-widget/seg-profile-summary-widget.component';

@NgModule({
  declarations: [GridWidgetComponent],
  imports: [CommonModule, TranslateModule, SampleStatusWidgetComponent, ExceedanceComplianceWidgetComponent, EquipmentCalibrationStatusWidgetComponent, SurveyProgressWidgetComponent, SampleCollectionMetricsWidgetComponent, SegProfileSummaryWidgetComponent],
  exports: [GridWidgetComponent, SampleStatusWidgetComponent, ExceedanceComplianceWidgetComponent, EquipmentCalibrationStatusWidgetComponent, SurveyProgressWidgetComponent, SampleCollectionMetricsWidgetComponent, SegProfileSummaryWidgetComponent]
})
export class DashboardWidgetsModule { }

export * from './dashboard-widget-registry';
